import { AfterViewInit, Component, inject, OnInit } from "@angular/core";
import moment from "moment";
import {
	ActionStackBackupService,
	ApiLoggerService,
	AppState,
	BlockedStackService,
	CentresSesamFindAllIfNew,
	CheckupStackService,
	CronService,
	GetVersionSesam,
	OrdoFavoriSeanceFacade,
	Persistence,
	selectCurrentConfig,
	selectCurrentIdel,
	ServerService,
	ThemeService,
	ToastrAyService,
} from "features";
import { MobileConfig, MobileIdel } from "@jack-sparrow-libraries/emotion-models";
import { Store } from "@ngrx/store";
import { format } from "date-fns";
import { Observable } from "rxjs";
import { EmotionEventsService } from "@services/emotion-events.service";
import { EfactureRetourService } from "@services/efacture-retour.service";
import { createActivityTimeoutListeners } from "./core/auth/utils/activity-timeout-listeners";
import { environment } from "@env/environment";
import { CommandMobileFacade } from "@services/facades/command-mobile.facade";
import { CotixLauncherService } from "@featuresAY/cotix/cotix-launcher/cotix-launcher.service";

@Component({
	standalone: false,
	selector: "app-root",
	templateUrl: "./app-ay.component.html",
})
export class AppAyComponent implements OnInit, AfterViewInit {
	idel$: Observable<MobileIdel>;
	config$: Observable<MobileConfig>;

	cotixService = inject(CotixLauncherService);
	private readonly efactureRetourService = inject(EfactureRetourService);

	constructor(
		private store: Store<AppState>,
		private serverService: ServerService,
		private cronService: CronService,
		private checkupStackService: CheckupStackService,
		private blockedStackService: BlockedStackService,
		private apiLoggerService: ApiLoggerService,
		private toastr: ToastrAyService,
		private persistenceService: Persistence,
		private actionStackBackupService: ActionStackBackupService,
		private emotionEventsService: EmotionEventsService,
		private favoriSeanceFacade: OrdoFavoriSeanceFacade,
		private themeService: ThemeService,
		private commandMobileFacade: CommandMobileFacade,
	) {
		this.commandMobileFacade.loadGroupeEntityEnvironnement();
		let activityDelay: number = environment.activityDelay;
		if (localStorage.getItem("activityDelay") && !isNaN(+localStorage.getItem("activityDelay"))) {
			activityDelay = +localStorage.getItem("activityDelay") * 1000;
		}
		createActivityTimeoutListeners(activityDelay);
		Date.prototype.toJSON = function () {
			return format(this, "yyyy-MM-dd'T'HH:mm:ss");
		};
	}

	ngOnInit() {
		this.emotionEventsService.initEmotionEvents();
		// Retour du login SSO e-factures : Struts nous a servi son action par defaut,
		// on rejoue la route V2 memorisee avant la redirection.
		this.efactureRetourService.restaurerRouteApresLogin();
	}

	async ngAfterViewInit() {
		await this.startup();
		window.dispatchEvent(new CustomEvent("send-current-user"));
		// Rustine : après un rechargement (F5) la liste des patients peut être perdue, on relance son chargement si les données sont initialisées et que l'utilisateur est authentifié.
		const isInitialized = this.persistenceService.get("dataInitialized");
		const isAuthKeyProvided = localStorage.getItem("authToken");
		if (isInitialized && isAuthKeyProvided) {
			this.commandMobileFacade.loadGroupEntityPatient();
		}
		moment.locale("fr");
		this.cotixService.initCotix();
	}

	async startCron() {
		this.cronService.startCron();
		this.cronService.addAction({
			label: "checkupStack",
			callback: CheckupStackService.checkup,
			arg: {
				checkupStackService: this.checkupStackService,
				apiLoggerService: this.apiLoggerService,
				actionStackBackupService: this.actionStackBackupService,
			},
			network: false,
			delay: {
				m: 2,
			},
		});
		this.cronService.addAction({
			label: "blockedStack",
			callback: BlockedStackService.checkup,
			arg: {
				blockedStackService: this.blockedStackService,
				checkupStackService: this.checkupStackService,
				apiLoggerService: this.apiLoggerService,
			},
			network: false,
			delay: {
				h: 24,
			},
		});
		this.cronService.addAction({
			label: "checkSesam",
			action: new GetVersionSesam(),
			delay: { h: 12 },
			network: true,
			logged: true,
		});

		this.cronService.addAction({
			label: "loadFavoriCommunes",
			callback: this.favoriSeanceFacade.loadAllFavoriSeances,
			delay: { h: 24 },
			network: true,
			logged: true,
			config: true,
		});

		this.cronService.addAction({
			label: "updateCentresSesam",
			action: new CentresSesamFindAllIfNew(),
			delay: { h: 24 },
			network: true,
			logged: true,
		});
	}

	async startup(): Promise<void> {
		await this.persistenceService.init();
		void this.startCron();
		await this.serverService.loadServer(); // détermination serveur de connexion
		this.toastr.setAnimations();
		this.config$ = this.store.select(selectCurrentConfig);
		this.idel$ = this.store.select(selectCurrentIdel);
	}
}
